import { render } from "./PendingEmailVerificationBanner.vue?vue&type=template&id=40501187"
import script from "./PendingEmailVerificationBanner.vue?vue&type=script&lang=js"
export * from "./PendingEmailVerificationBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__